import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Upload, ArrowLeft } from 'lucide-react';
type FormData = {
  name: string;
  phone: string;
  email: string;
  brand: string;
  model: string;
  year: string;
  kilometers: string;
  condition: string;
  photos: File[];
};
export function SellForm() {
  const [step, setStep] = useState(1);
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState<FormData>({
    name: '',
    phone: '',
    email: '',
    brand: '',
    model: '',
    year: '',
    kilometers: '',
    condition: '',
    photos: []
  });
  const [errors, setErrors] = useState<Partial<FormData>>({});
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [termsError, setTermsError] = useState('');
  const validateStep1 = () => {
    const newErrors: Partial<FormData> = {};
    if (!formData.name.trim()) newErrors.name = 'Ime in priimek je obvezno';
    if (!formData.phone.trim()) newErrors.phone = 'Telefon je obvezen';
    if (!formData.email.trim()) newErrors.email = 'E-pošta je obvezna';else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Vnesite veljaven e-poštni naslov';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleStep1Continue = () => {
    if (validateStep1()) {
      console.log('Contact data saved:', {
        name: formData.name,
        phone: formData.phone,
        email: formData.email
      });
      setStep(2);
    }
  };
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormData({
        ...formData,
        photos: Array.from(e.target.files)
      });
    }
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!acceptedTerms) {
      setTermsError('Strinjanje s pogoji je obvezno.');
      return;
    }
    setTermsError('');
    console.log('Form submitted:', formData);
    setSubmitted(true);
  };
  if (submitted) {
    return <section id="form" className="py-16 md:py-24 bg-slate-50" data-id="element-235">
        <div className="container mx-auto px-4" data-id="element-236">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} className="max-w-2xl mx-auto bg-white rounded-2xl shadow-lg p-8 md:p-12 text-center" data-id="element-237">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-emerald-100 rounded-full mb-6" data-id="element-238">
              <CheckCircle className="w-8 h-8 text-emerald-600" data-id="element-239" />
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-slate-900 mb-4" data-id="element-240">
              Hvala za vaše zaupanje!
            </h3>
            <p className="text-lg text-slate-600 mb-2" data-id="element-241">
              Vaši podatki so bili uspešno poslani.
            </p>
            <p className="text-slate-600" data-id="element-242">
              Vaš osebni svetovalec vas bo kontaktiral v 24 urah z brezplačno
              cenitvijo in naslednjimi koraki.
            </p>
          </motion.div>
        </div>
      </section>;
  }
  return <section id="form" className="py-16 md:py-24 bg-slate-50" data-id="element-243">
      <div className="container mx-auto px-4" data-id="element-244">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto" data-id="element-245">
          <div className="text-center mb-6" data-id="element-246">
            <p className="text-sm text-slate-600" data-id="element-247">
              Oddaja traja manj kot 2 minuti. Brez obveznosti.
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8" data-id="element-248">
            {/* Progress Bar */}
            <div className="mb-8" data-id="element-249">
              <div className="flex items-center justify-between mb-2" data-id="element-250">
                <span className="text-sm font-medium text-slate-600" data-id="element-251">
                  Korak {step}/2
                </span>
                <span className="text-sm text-slate-500" data-id="element-252">
                  {step === 1 ? 'Kontaktni podatki' : 'Podatki o vozilu'}
                </span>
              </div>
              <div className="h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-253">
                <div className="h-full bg-[#1EB6E8] transition-all duration-300" style={{
                width: `${step / 2 * 100}%`
              }} data-id="element-254"></div>
              </div>
            </div>

            {step === 1 ? <div data-id="element-255">
                <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-256">
                  Vaši podatki
                </h3>
                <p className="text-slate-600 mb-6" data-id="element-257">
                  Pustite nam svoj kontakt, ostalo uredimo skupaj.
                </p>

                <div className="space-y-4" data-id="element-258">
                  <div data-id="element-259">
                    <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-260">
                      Ime in priimek *
                    </label>
                    <input type="text" value={formData.name} onChange={e => setFormData({
                  ...formData,
                  name: e.target.value
                })} className={`w-full px-4 py-3 rounded-lg border ${errors.name ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-[#1EB6E8] focus:border-transparent outline-none transition-all`} placeholder="Janez Novak" data-id="element-261" />
                    {errors.name && <p className="text-red-500 text-sm mt-1" data-id="element-262">{errors.name}</p>}
                  </div>

                  <div data-id="element-263">
                    <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-264">
                      Telefon *
                    </label>
                    <input type="tel" value={formData.phone} onChange={e => setFormData({
                  ...formData,
                  phone: e.target.value
                })} className={`w-full px-4 py-3 rounded-lg border ${errors.phone ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-[#1EB6E8] focus:border-transparent outline-none transition-all`} placeholder="+386 31 234 567" data-id="element-265" />
                    {errors.phone && <p className="text-red-500 text-sm mt-1" data-id="element-266">
                        {errors.phone}
                      </p>}
                  </div>

                  <div data-id="element-267">
                    <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-268">
                      E-pošta *
                    </label>
                    <input type="email" value={formData.email} onChange={e => setFormData({
                  ...formData,
                  email: e.target.value
                })} className={`w-full px-4 py-3 rounded-lg border ${errors.email ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-[#1EB6E8] focus:border-transparent outline-none transition-all`} placeholder="janez.novak@email.com" data-id="element-269" />
                    {errors.email && <p className="text-red-500 text-sm mt-1" data-id="element-270">
                        {errors.email}
                      </p>}
                  </div>
                </div>

                <div className="mt-6 p-4 bg-emerald-50 rounded-lg border border-emerald-200" data-id="element-271">
                  <p className="text-sm text-emerald-800" data-id="element-272">
                    🔒 Vaši podatki so varni in jih ne delimo s tretjimi
                    osebami.
                  </p>
                </div>

                <button onClick={handleStep1Continue} className="w-full mt-6 px-6 py-3.5 bg-[#1EB6E8] text-white rounded-lg font-medium hover:bg-[#1aa3d1] transition-colors" data-id="element-273">
                  Nadaljuj
                </button>
              </div> : <form onSubmit={handleSubmit} data-id="element-274">
                <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-275">
                  Podatki o vašem vozilu
                </h3>
                <p className="text-slate-600 mb-6" data-id="element-276">
                  Povejte nam nekaj osnovnih podatkov o vozilu.
                </p>

                <div className="space-y-4" data-id="element-277">
                  <div data-id="element-278">
                    <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-279">
                      Znamka *
                    </label>
                    <select value={formData.brand} onChange={e => setFormData({
                  ...formData,
                  brand: e.target.value
                })} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#1EB6E8] focus:border-transparent outline-none transition-all" required data-id="element-280">
                      <option value="" data-id="element-281">Izberite znamko</option>
                      <option value="Volkswagen" data-id="element-282">Volkswagen</option>
                      <option value="BMW" data-id="element-283">BMW</option>
                      <option value="Mercedes-Benz" data-id="element-284">Mercedes-Benz</option>
                      <option value="Audi" data-id="element-285">Audi</option>
                      <option value="Renault" data-id="element-286">Renault</option>
                      <option value="Peugeot" data-id="element-287">Peugeot</option>
                      <option value="Toyota" data-id="element-288">Toyota</option>
                      <option value="Škoda" data-id="element-289">Škoda</option>
                      <option value="Drugo" data-id="element-290">Drugo</option>
                    </select>
                  </div>

                  <div data-id="element-291">
                    <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-292">
                      Model *
                    </label>
                    <input type="text" value={formData.model} onChange={e => setFormData({
                  ...formData,
                  model: e.target.value
                })} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#1EB6E8] focus:border-transparent outline-none transition-all" placeholder="Golf" required data-id="element-293" />
                  </div>

                  <div className="grid grid-cols-2 gap-4" data-id="element-294">
                    <div data-id="element-295">
                      <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-296">
                        Letnik *
                      </label>
                      <input type="number" value={formData.year} onChange={e => setFormData({
                    ...formData,
                    year: e.target.value
                  })} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#1EB6E8] focus:border-transparent outline-none transition-all" placeholder="2020" min="1990" max={new Date().getFullYear()} required data-id="element-297" />
                    </div>

                    <div data-id="element-298">
                      <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-299">
                        Kilometri *
                      </label>
                      <input type="number" value={formData.kilometers} onChange={e => setFormData({
                    ...formData,
                    kilometers: e.target.value
                  })} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#1EB6E8] focus:border-transparent outline-none transition-all" placeholder="50000" required data-id="element-300" />
                    </div>
                  </div>
                </div>

                <div className="mt-6" data-id="element-301">
                  <label className="flex items-start gap-3 cursor-pointer" data-id="element-302">
                    <input type="checkbox" checked={acceptedTerms} onChange={e => {
                  setAcceptedTerms(e.target.checked);
                  if (e.target.checked) setTermsError('');
                }} className="mt-1 w-4 h-4 text-[#1EB6E8] border-gray-300 rounded focus:ring-[#1EB6E8]" data-id="element-303" />
                    <span className="text-sm text-slate-700" data-id="element-304">
                      Strinjam se s{' '}
                      <a href="#" className="text-[#1EB6E8] hover:underline" data-id="element-305">
                        splošnimi pogoji
                      </a>{' '}
                      in{' '}
                      <a href="#" className="text-[#1EB6E8] hover:underline" data-id="element-306">
                        politiko zasebnosti
                      </a>
                      .
                    </span>
                  </label>
                  {termsError && <p className="text-red-500 text-sm mt-2" data-id="element-307">{termsError}</p>}
                </div>

                <div className="flex gap-3 mt-6" data-id="element-308">
                  <button type="button" onClick={() => setStep(1)} className="flex items-center gap-2 px-6 py-3 border border-gray-300 text-slate-700 rounded-lg font-medium hover:bg-gray-50 transition-colors" data-id="element-309">
                    <ArrowLeft className="w-4 h-4" data-id="element-310" />
                    Nazaj
                  </button>
                  <button type="submit" className="flex-1 px-6 py-3.5 bg-[#1EB6E8] text-white rounded-lg font-medium hover:bg-[#1aa3d1] transition-colors" data-id="element-311">
                    Pošlji
                  </button>
                </div>
              </form>}
          </div>
        </motion.div>
      </div>
    </section>;
}